<template>
  <div class="chart">
    <div class="nav">
      <div class="nav-List" v-for="(item,index) in list" :key="item.id" @click="toTarget(index)">
        {{item.name}}
      </div>
    </div>
    <div class="content">
      <div
          class="content-item"
          v-for="item in list" :key="item.id">
        {{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      element:{
        nav:[],
        content:[]
      },
      list:[
        {id:1,name:"F1"},
        {id:2,name:"F2"},
        {id:3,name:"F3"},
        {id:4,name:"F4"},
        {id:5,name:"F5"},
        {id:6,name:"F6"},
        {id:7,name:"F7"},
        {id:8,name:"F8"},
        {id:9,name:"F9"}
      ]
    }
  },
  mounted(){
    const nav = document.getElementsByClassName('nav-List')
    const cont = document.getElementsByClassName('content-item')
    this.element.nav = nav
    this.element.content = cont
    //导航初始化样式（默认第一个）
    nav[0].classList.add('active')
    //事件监听
    window.addEventListener("scroll",this.toScroll)
  },
  beforeDestroy(){
    //结束移出监听
    window.removeEventListener('scroll',this.toScroll)
  },
  methods:{
    //点击导航
    toTarget(index){
      const {content,nav} = this.element
      for(let n = 0;n<nav.length;n++){
        n==index?nav[n].classList.add('active'):nav[n].classList.remove('active')
      }
      const offset_top = content[index].offsetTop
      document.documentElement.scrollTop = offset_top+10
    },
    //屏幕滚动
    toScroll(){
      //获取滚动距离
      const scrollTop = document.documentElement.scrollTop||document.body.scrollTop
      const {content,nav} = this.element
      for(let i = 0,len = content.length;i<len;i++){
        //获取每块内容距离顶部距离
        const offset = content[i].offsetTop
        //当划过第一块内容 改变左侧导航样式
        if(scrollTop>=offset){
          for(let n = 0;n<len;n++){
            n==i?nav[n].classList.add('active'):nav[n].classList.remove('active')
          }
        }
      }
    }
  },
}
</script>

<style scoped>
.nav{
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  .nav-List{
    width: 50px;
    height: 50px;
    border: 1px dashed grey;
    border-bottom:0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
  }
  .nav-List:nth-last-child(1){
    border: 1px dashed grey;
  }
  .active,
  .nav-List:hover{
    background: grey;
    color: white;
  }
}
.content-item{
  width: 100%;
  height: 100vh;
  font-size: 100px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;

}
.content-item:nth-of-type(1){
  background: chartreuse;
}
.content-item:nth-of-type(2){
  background: red;
}
.content-item:nth-of-type(3){
  background: pink;
}
.content-item:nth-of-type(4){
  background: grey;
}
.content-item:nth-of-type(5){
  background: blue;
}
.content-item:nth-of-type(6){
  background: orange;
}
.content-item:nth-of-type(7){
  background: goldenrod;
}
.content-item:nth-of-type(8){
  background: forestgreen;
}
.content-item:nth-of-type(9){
  background: teal;
}
</style>
